import { render, staticRenderFns } from "./HeaderExits.vue?vue&type=template&id=8620f244"
import script from "./HeaderExits.vue?vue&type=script&lang=js"
export * from "./HeaderExits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports